/* Shared helpers for the "All Fitments" data (assets/alladmindata.json).
   Used by the home page vehicle selector (customddAndSearch-snippet-upgrated)
   and the /pages/all-fitments section (c-all-fitments). Loads nothing by itself. */
window.PCFitments = window.PCFitments || (function () {
  'use strict';

  const ROUTES_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const PENDING_KEY = 'pcAllFitmentsPending';
  const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

  /* url → Promise<makes[]>; each file is fetched once per page view */
  const cache = {};

  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then(data => (Array.isArray(data) ? data : [])
          .filter(m => m && m.make)
          .map(m => ({
            make: m.make,
            models: (m.models || [])
              .filter(md => md && md.model)
              .map(md => ({ model: md.model, variants: (md.variants || []).filter(Boolean) }))
              .sort((a, b) => collator.compare(a.model, b.model)),
          }))
          .sort((a, b) => collator.compare(a.make, b.make)))
        .catch(err => {
          delete cache[url]; /* allow a retry */
          throw err;
        });
    }
    return cache[url];
  }

  /* "PC07-FT" → "pc07" — the suffix after the dash is never part of the product handle */
  function productHandle(socket) {
    return String(socket || '').split('-')[0].trim().toLowerCase();
  }

  /* First variant id of the PC unit product for this socket */
  async function variantIdForSocket(socket) {
    const handle = productHandle(socket);
    if (!handle) throw new Error('Missing socket');
    const res = await fetch(`${ROUTES_ROOT}products/${encodeURIComponent(handle)}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    const variant = (data.variants || [])[0];
    if (!variant) throw new Error('No variant');
    return variant.id;
  }

  /* Out of stock in THIS market? window.outOfStockPcCodes is set on every page by
     snippets/out-of-stock-pc-codes from the theme setting rule (PC25, PC39!de!eu) */
  function isOutOfStock(socket) {
    const code = productHandle(socket).toUpperCase();
    const list = window.outOfStockPcCodes || [];
    return !!code && list.some(c => String(c).trim().toUpperCase() === code);
  }

  /* Cart line property, same shape as the INT quick-buy: PC code / make / model / body / engine */
  function selectionLabel(fit) {
    return [productHandle(fit.socket).toUpperCase(), fit.make, fit.model, fit.body, fit.engine]
      .filter(Boolean)
      .join(' / ');
  }

  function same(a, b) {
    return String(a || '').trim().toLowerCase() === String(b || '').trim().toLowerCase();
  }

  function sameFitment(a, b) {
    return !!a && !!b &&
      same(a.make, b.make) && same(a.model, b.model) &&
      same(a.body, b.body) && same(a.engine, b.engine) && same(a.socket, b.socket);
  }

  /* One-shot "add this to the cart" hand-off from the home page to the fitments page.
     Session storage (not the URL) so a refresh or a shared link never adds to the cart again. */
  function setPending(fit) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify(fit)); } catch (_) { /* storage blocked */ }
  }

  function takePending() {
    try {
      const raw = sessionStorage.getItem(PENDING_KEY);
      sessionStorage.removeItem(PENDING_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_) {
      return null;
    }
  }

  /* Fitments page URL carrying the selection, e.g. /pages/all-fitments?make=Abarth&model=500&body=… */
  function pageUrl(base, fit) {
    const params = new URLSearchParams();
    ['make', 'model', 'body', 'engine'].forEach(k => { if (fit && fit[k]) params.set(k, fit[k]); });
    const qs = params.toString();
    return qs ? `${base}?${qs}` : base;
  }

  return { load, productHandle, variantIdForSocket, isOutOfStock, selectionLabel, sameFitment, setPending, takePending, pageUrl, collator };
})();
